























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import SuporteSecretariasStore, { TipoUsuarioAgendamento } from '@/components/Suporte/Store/SuporteSecretariasStore'
import ModalSuporteSecretaria from '@/components/Suporte/components/ModalSuporteSecretaria.vue'
import { DataTablePagination } from '@/types/_'
import { maskCPFCNPJ } from '@/utils/common'

@Component({
  components: {
    ModalSuporteSecretaria,
  },
})
export default class ViewSuporteSecretarias extends Vue {
  loadSecretarias: boolean = false
  loadEditarSecretaria: string = ''
  loadAdicionarSecretaria: boolean = false

  get getSuporteSecretariasStore() {
    return getModule(SuporteSecretariasStore, this.$store)
  }

  get paginationSecretaria() { return this.getSuporteSecretariasStore.paginationSecretaria }

  get loadingEditarSecretaria() { return this.loadEditarSecretaria }
  set loadingEditarSecretaria(value: string) { this.loadEditarSecretaria = value }
  get loadingSecretarias() { return this.loadSecretarias }
  set loadingSecretarias(value: boolean) { this.loadSecretarias = value }
  get loadingAdicionarSecretaria() { return this.loadAdicionarSecretaria }
  set loadingAdicionarSecretaria(value: boolean) { this.loadAdicionarSecretaria = value }

  get secretariasHeaders() {
    return [
      { text: 'Nome', value: 'nome', sortable: false },
      { text: 'Documento', value: 'documento', sortable: false },
      { text: 'E-mail', value: 'emial', sortable: false },
      { text: 'Tipo de usuário', value: 'tipoUsuarioAgendamento', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get secretarias() { return this.getSuporteSecretariasStore.secretarias }
  get searchSecretaria() { return this.getSuporteSecretariasStore.searchSecretaria }
  set searchSecretaria(value: string) { this.getSuporteSecretariasStore.setSearchSecretaria(value) }

  maskDocumento(value: string) {
    return maskCPFCNPJ(value)
  }

  maskTipoUsuario(value: string) {
    if (value === 'SecretariaDoAgendamento') return 'Secretária do agendamento'
    if (value === 'SecretariaDoAmbulatorio') return 'Secretária do ambulatório'
    if (value === 'SecretariaDoMedico') return 'Secretária do médico'
    return '-'
  }

  async updatePaginationSecretarias(pagination: DataTablePagination) {
    this.loadingSecretarias = true
    await this.getSuporteSecretariasStore.getSecretariaPagedSearch(pagination)
    this.loadingSecretarias = false
  }

  resetSearch() {
    this.searchSecretaria = ''
    this.getSuporteSecretariasStore.clearSecretarias()
  }

  async buscarSecretariasUsingKeyboard(e: Event) {
    // @ts-ignore
    if (['', undefined, null].includes(e.target.value)) return
    this.loadingSecretarias = true
    await this.getSuporteSecretariasStore.getSecretariaPagedSearch(this.getSuporteSecretariasStore.paginationSecretaria)
    this.loadingSecretarias = false
  }

  async buscarSecretarias(e: Event) {
    this.loadingSecretarias = true
    await this.getSuporteSecretariasStore.getSecretariaPagedSearch(this.getSuporteSecretariasStore.paginationSecretaria)
    this.loadingSecretarias = false
  }

  async adicionarSecretaria() {
    this.loadingAdicionarSecretaria = true
    this.getSuporteSecretariasStore.setMode('CREATE')
    this.getSuporteSecretariasStore.clearSecretaria()
    this.getSuporteSecretariasStore.setModal({ name: 'secretaria', value: true })
    this.loadingAdicionarSecretaria = false
  }

  async editarSecretaria(id: string) {
    this.loadingEditarSecretaria = id
    const response = await this.getSuporteSecretariasStore.getSecretariaById(id)

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao buscar a secretária ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadEditarSecretaria = ''
      return
    }

    this.getSuporteSecretariasStore.setMode('EDIT')
    this.getSuporteSecretariasStore.setModal({ name: 'secretaria', value: true })
    this.loadingEditarSecretaria = ''
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    await this.getSuporteSecretariasStore.getAllHospitalSuporteConfiguracao()
    EventBus.$emit('clearLoadingRequest')
  }

  beforeDestroy() {
    this.getSuporteSecretariasStore.clearSearchSecretaria()
    this.getSuporteSecretariasStore.clearSecretarias()
    this.getSuporteSecretariasStore.clearHospitais()
  }
}
